import { useState } from "react";
import { EnvelopeSimple, MapPin, Clock, InstagramLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "general", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Thank you — we'll be in touch within 24 hours.");
      setForm({ name: "", email: "", subject: "general", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send. Please email us directly.");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="contact-page">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <div className="overline text-[#4A1525] mb-4">Correspondence</div>
          <h1 className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-8">Get in<br/><em className="text-[#4A1525] font-light">touch.</em></h1>
          <p className="text-[#5C5C5C] text-lg leading-relaxed mb-12 max-w-md">
            Questions about a piece, a fit, a return, or something entirely private — we read every message ourselves.
          </p>

          <div className="space-y-8">
            <div className="flex gap-4">
              <EnvelopeSimple size={22} weight="light" color="#4A1525" className="flex-shrink-0 mt-1" />
              <div>
                <div className="overline text-[#5C5C5C] mb-1">Email</div>
                <a href="mailto:admin@iamravishing.com" className="text-[#1A1A1A] hover:text-[#4A1525]" data-testid="contact-email">admin@iamravishing.com</a>
              </div>
            </div>
            <div className="flex gap-4">
              <MapPin size={22} weight="light" color="#4A1525" className="flex-shrink-0 mt-1" />
              <div>
                <div className="overline text-[#5C5C5C] mb-1">Atelier</div>
                <div className="text-[#1A1A1A]">Mumbai, India<br/><span className="text-[#5C5C5C] text-sm">By appointment only</span></div>
              </div>
            </div>
            <div className="flex gap-4">
              <Clock size={22} weight="light" color="#4A1525" className="flex-shrink-0 mt-1" />
              <div>
                <div className="overline text-[#5C5C5C] mb-1">Hours</div>
                <div className="text-[#1A1A1A]">Monday – Saturday · 10:00 – 19:00 IST</div>
              </div>
            </div>
            <div className="flex gap-4">
              <InstagramLogo size={22} weight="light" color="#4A1525" className="flex-shrink-0 mt-1" />
              <div>
                <div className="overline text-[#5C5C5C] mb-1">Social</div>
                <a href="#" className="text-[#1A1A1A] hover:text-[#4A1525]">@iamravishing</a>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 bg-[#F0EBE1] p-8 lg:p-12 space-y-6" data-testid="contact-form">
          <h2 className="font-serif text-3xl mb-2">Send a note</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="overline block mb-2">Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border-b border-[#1A1A1A] bg-transparent py-3 focus:outline-none focus:border-[#4A1525]" data-testid="contact-name" />
            </div>
            <div>
              <label className="overline block mb-2">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border-b border-[#1A1A1A] bg-transparent py-3 focus:outline-none focus:border-[#4A1525]" data-testid="contact-email-input" />
            </div>
          </div>
          <div>
            <label className="overline block mb-2">Subject</label>
            <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full border-b border-[#1A1A1A] bg-transparent py-3 focus:outline-none" data-testid="contact-subject">
              <option value="general">General enquiry</option>
              <option value="order">Order support</option>
              <option value="fit">Fit & sizing</option>
              <option value="return">Return or exchange</option>
              <option value="press">Press & partnerships</option>
              <option value="wholesale">Wholesale</option>
            </select>
          </div>
          <div>
            <label className="overline block mb-2">Message</label>
            <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border-b border-[#1A1A1A] bg-transparent py-3 focus:outline-none focus:border-[#4A1525] resize-none" data-testid="contact-message" />
          </div>
          <button type="submit" disabled={busy} className="bg-[#4A1525] text-[#FAF8F5] px-10 py-4 overline hover:bg-[#360F1B] transition-colors disabled:opacity-50" data-testid="contact-submit">
            {busy ? "Sending..." : "Send message"}
          </button>
          <p className="text-xs text-[#5C5C5C]">We reply within 24 hours, Monday to Saturday.</p>
        </form>
      </section>
    </div>
  );
}
